export enum sectionTypes {
  SEPARATOR = 'Separator',
  CONTENT = 'Content',
}

/**
 * Limits applied to reference files attached to AI widgets.
 * Enforced by the widget editor, the Composer upload API, and the backend AI endpoints,
 * so they must be read from here rather than redefined per application.
 */
export const AI_WIDGET_FILE_LIMITS = {
  /** Maximum number of files a single AI widget may reference */
  MAX_COUNT: 5,
  /** Maximum size of one attached file, in bytes */
  MAX_FILE_SIZE_BYTES: 20 * 1024 * 1024,
  /** Maximum combined size of all files attached to one widget, in bytes */
  MAX_TOTAL_SIZE_BYTES: 50 * 1024 * 1024,
} as const

/**
 * File extensions accepted as AI widget reference files.
 *
 * Attachments are only ever consumed through OpenAI file search, so this list is
 * restricted to the formats OpenAI vector stores can ingest. Spreadsheets and images
 * are deliberately excluded: they upload successfully but fail at ingestion time.
 */
export const AI_WIDGET_SUPPORTED_FILE_EXTENSIONS = [
  'doc',
  'docx',
  'html',
  'json',
  'md',
  'pdf',
  'pptx',
  'tex',
  'txt',
] as const
